import { PersonGeneratedEntity } from "./generated/PersonGeneratedEntity";

export abstract class PersonEntity extends PersonGeneratedEntity {
    // Comment to preserve new line
}
